import { memo } from "react";
import {
  Menu,
  MenuItem,
  Divider,
  Typography,
  IconButton,
  Tooltip,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { CONFIG } from "../../config";

/**
 * User account menu component
 */
const UserMenu = ({
  anchorEl,
  userImage,
  user,
  onMenuOpen,
  onMenuClose,
  onNavigate,
  onLogout,
}) => {
  const { t } = useTranslation("common");
  const open = Boolean(anchorEl);

  return [
    <Tooltip title={t("common.account")} placement="bottom" arrow key="tooltip">
      <IconButton
        aria-label={t("common.account_current_user")}
        aria-controls="menu-appbar"
        aria-haspopup="true"
        onClick={onMenuOpen}
        color="inherit"
      >
        {userImage}
      </IconButton>
    </Tooltip>,
    <Menu
      id="menu-appbar"
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={open}
      onClose={onMenuClose}
      key="menu"
    >
      {user && user.email && (
        <MenuItem disabled>
          <Typography variant="body2" noWrap>
            {user.email}
          </Typography>
        </MenuItem>
      )}

      <Divider />

      <MenuItem
        onClick={() => {
          onMenuClose();
          onNavigate("/account");
        }}
      >
        {t("common.account")}
      </MenuItem>

      <MenuItem
        onClick={() => {
          onMenuClose();
          onNavigate("/organisation");
        }}
      >
        {t("common.manage_organisations")}
      </MenuItem>

      <Divider />

      {CONFIG.feedback_enabled && (
        <MenuItem
          onClick={() => {
            window.location.href = CONFIG.feedback_url;
          }}
        >
          {t("common.feedback")}
        </MenuItem>
      )}

      <MenuItem onClick={onLogout}>{t("common.logout")}</MenuItem>
    </Menu>,
  ];
};

UserMenu.propTypes = {
  anchorEl: PropTypes.object,
  userImage: PropTypes.node.isRequired,
  user: PropTypes.object,
  themeMode: PropTypes.string,
  onMenuOpen: PropTypes.func.isRequired,
  onMenuClose: PropTypes.func.isRequired,
  onNavigate: PropTypes.func.isRequired,
  onLogout: PropTypes.func.isRequired,
  theme: PropTypes.object.isRequired,
};

export default memo(UserMenu);
